<template>
  <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="checkData()"/>
</template>

<script>

import 'jspdf-autotable'
import jsPDF from "jspdf";
import {font} from "./assets/THSarabunNew-normal";
import {font_bold} from "./assets/THSarabunNew-bold";
import moduleMember from "@/store/member/moduleMember.js";
import moduleConfig from "@/store/config/moduleConfig.js";
import moment from "moment";

export default {
  components: {
    jsPDF,
  },
  name: "RealUserReport",
  data() {
    return {
      orgData: '',
      date: ''
    }
  },
  methods: {
    currentThaiDate() {
      const date = moment().format('DD/MM/YYYY');
      const dateSplit = date.split('/');
      const year = parseInt(dateSplit[2]) + 543;
      return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
    },
    warningDialog(message) {
      this.$vs.dialog({
        type: 'alert',
        color: 'warning',
        title: `คำเตือน`,
        text: message,
        acceptText: 'ปิด'
      })
    },
    async checkData() {
      this.$vs.loading();
      this.orgData = await this.$store.state.config.item;
      let name = 'สรุปยอดผู้ชำระค่าขยะแต่ละประเภท';
      const payload = {};
      await this.getMember(payload, name);
    },
    async getMember(payload, name) {
      await this.$store.dispatch("member/fetchDataListByFilter", payload).then((res) => {
        if (res.status === 200 && res.data.length !== 0) {
          const member = res.data;
          this.generatePDF(member);
          this.$vs.loading.close();
        } else {
          this.warningDialog('ไม่มีรายชื่อ' + name);
          this.$vs.loading.close();
        }
      }).catch((error) => {
        this.warningDialog('ไม่มีรายชื่อ' + name);
        this.$vs.loading.close();
      });
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    generatePDF(member) {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [279.4, 210]
      });
      const orgData = this.orgData;
      const area = this.area;
      const date = this.currentThaiDate();
      let title;
      let header;
      let array = [];
      let areaList = [];
      title = 'สรุปยอดผู้ชำระค่าขยะ';
      header = ['เขต', 'ทั้งหมด', '1 เดือน', '3 เดือน', '4 เดือน', '6 เดือน', '1 ปี'];
      let memberList = this.groupBy(member, 'M02');
      Object.keys(memberList).forEach(function (key) {
        const all = memberList[key].length
        const month = memberList[key].filter((item) => {
          return item.type === '1'
        }).length
        const threeMonth = memberList[key].filter((item) => {
          return item.type === '3'
        }).length
        const fourMonth = memberList[key].filter((item) => {
          return item.type === '4'
        }).length
        const sixMonth = memberList[key].filter((item) => {
          return item.type === '6'
        }).length
        const year = memberList[key].filter((item) => {
          return item.type === '12'
        }).length
        areaList.push({member_area: key, all, month, threeMonth, fourMonth, sixMonth, year});
      })
      areaList.sort((a, b) => parseInt(a['member_area']) - parseInt(b['member_area']));
      let all = 0;
      let month = 0;
      let threeMonth = 0;
      let fourMonth = 0;
      let sixMonth = 0;
      let year = 0;
      areaList.forEach(function (item) {
        array.push([item.member_area,
          item.all,
          item.month,
          item.threeMonth,
          item.fourMonth,
          item.sixMonth,
          item.year
        ])
        all += parseFloat(item.all);
        month += parseFloat(item.month);
        threeMonth += parseFloat(item.threeMonth);
        fourMonth += parseFloat(item.fourMonth);
        sixMonth += parseFloat(item.sixMonth);
        year += parseFloat(item.year);
      })

      array.push(['', 'รวมทั้งสิ้น ' + member.length + ' ราย', month + ' ราย', threeMonth + ' ราย', fourMonth + ' ราย', sixMonth + ' ราย', year + ' ราย'])

      var totalPagesExp = '{total_pages_count_string}';
      doc.addFileToVFS('THSarabunNew-normal.ttf', font);
      doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
      doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
      doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
      doc.setFont('THSarabunNew', 'bold');
      doc.setFontSize(14);
      doc.autoTable({
        styles: {font: 'THSarabunNew', fontSize: 14},
        margin: {left: 8, top: 33, right: 8},
        theme: 'plain',
        head: [header],
        body: array,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(18);
          doc.text(orgData.Org01, doc.internal.pageSize.getWidth() / 2, 10, {align: 'center'});
          doc.text(orgData.Org03, doc.internal.pageSize.getWidth() / 2, 16, {align: 'center'});
          doc.setFontSize(16);
          doc.text(title, doc.internal.pageSize.getWidth() / 2, 23, {align: 'center'});
          // Footer
          // doc.setFont('THSarabunNew', 'normal');
          // doc.setFontSize(14);
          // var str = 'Page ' + doc.internal.getNumberOfPages();
          // if (typeof doc.putTotalPages === 'function') {
          //   str = str + ' of ' + totalPagesExp
          // }
          // doc.setFontSize(12);
          // var pageSize = doc.internal.pageSize;
          // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          // doc.text(moment().format('DD/MM/YYYY'), 10, pageHeight - 10,)
          // doc.text(str, 230, pageHeight - 10, {align: 'right'});
        },
      });
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }
      const pages = doc.internal.getNumberOfPages();
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      for (let j = 1; j < pages + 1; j++) {
        doc.setPage(j);
        doc.addFileToVFS('THSarabunNew-normal.ttf', font);
        doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
        doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
        doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
        doc.setFont('THSarabunNew', 'normal');
        doc.setFontSize(12);
        doc.text('วันที่พิมพ์ ' + date, 10, pageHeight - 8,)
        doc.text(`หน้าที่พิมพ์ ${j} of ${pages}`, 180, pageHeight - 8, {align: 'center'})
      }
      doc.save(title + moment().format('DD-MM-YYYY') + '.pdf');
    }
  },
  async created() {
    if (!moduleMember.isRegistered) {
      this.$store.registerModule('member', moduleMember);
      moduleMember.isRegistered = true;
    }
    if (!moduleConfig.isRegistered) {
      this.$store.registerModule('config', moduleConfig)
      moduleConfig.isRegistered = true
    }
    await this.$store.dispatch("config/fetchDataItem");
  }
}
</script>

<style scoped>
</style>
